import { Button } from "@App/Components/Funnel/Button";
import { NumberPlateInput } from "@App/Components/NumberPlateInput";
import { Headline } from "@App/Components/atoms/common/Headline";
import { Input } from "@App/Components/common/Input";
import { useReturnIdentity } from "@App/hooks/vehicleReturn/useReturnIdentity";
import type { State } from "@App/state";
import { Fragment, type FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export type DeliveryIdentityProps = {
  onSubmit: () => void;
};

export const ReturnIdentity: FunctionComponent<DeliveryIdentityProps> = ({
  onSubmit,
}: DeliveryIdentityProps) => {
  const { t } = useTranslation();

  const organizationId = useSelector((state: State) => state.orders.organization.id);

  const { onClick, error, loading, buttonDisabled, setAgreementNumber, setNumberplate } =
    useReturnIdentity(onSubmit, organizationId);

  return (
    <Fragment>
      <div className={"container md:w-[600px] m-5 min-h-screen mx-auto mt-20"}>
        <div>
          <Headline type="h1">{t("vehicleReturn.identity-headline")}</Headline>
          <p className={"text-neutral-500"}>{t("vehicleReturn.identity-text")}</p>

          <div className="flex flex-col gap-5 mt-5 mb-3">
            <div className={"flex-1 flex-col"}>
              <label htmlFor="name">{t("vehicleReturn.identity-name")}</label>
              <NumberPlateInput disabled={loading} onChange={setNumberplate} />
            </div>

            <div className={"flex-1 flex-col"}>
              <label htmlFor="agreementNumber">
                {t("vehicleReturn.identity-agreement-number")}
              </label>
              <Input
                disabled={loading}
                id="agreementNumber"
                type="text"
                className={"w-full !my-0 !shadow-none"}
                placeholder={"1234567"}
                onChange={setAgreementNumber}
              />
            </div>
          </div>

          {error && <p className={"text-error-500"}>{t("vehicleReturn.identity-error")}</p>}

          <Button
            title={
              loading ? t("vehicleReturn.identity-loading") : t("vehicleReturn.identity-button")
            }
            onClick={onClick}
            disabled={buttonDisabled}
          />
        </div>
      </div>
    </Fragment>
  );
};
